<script lang="ts">
  import { Image, Label } from "sveltestrap";
  import data from "../../../../Data/Email/Email.json"
  let imgPath:string = "/assets/images/user"
  
</script>
<div class="inbox">
    {#each data.indoxmedia as inboxItem}
        <div class="media">
            <div class="media-size-email">                                       
                <Label class="d-block mb-0" for="chk-ani">
                    <input class="checkbox_animated" id="chk-ani" type="checkbox" checked={inboxItem.checked}>
                </Label>
                <i class="like" data-feather="star"></i>
                <Image class="me-3 rounded-circle" src="{imgPath}/user.png" alt="" />
            </div>
            <div class="media-body">
                <h6>{inboxItem.name} </h6>
                <p>{inboxItem.detail}</p>
                <span>{inboxItem.time}</span>
            </div>
        </div>
    {/each}
</div>